import { request, setRequestRetry } from '@/utils/request';
import {
  OrderSetPriceParams,
  OrderCancelByPharmParams,
  OrderPickupCallParams,
  RequestedOrdersParams,
  PreparingOrdersParams,
  SettlementsParams
} from '@/apis/order/interface';

/** [주문] 주문 목록 조회 */

export const getRequestedOrders = async (
  token: string,
  params: RequestedOrdersParams
) => {
  const {
    data: { result }
  } = await request(token, 'v2').get('/orders/requested', {
    params
  });
  return result;
};

export const getPreparingOrders = async (
  token: string,
  params: PreparingOrdersParams
) => {
  const {
    data: { result }
  } = await request(token, 'v2').get('/orders/preparing', {
    params
  });
  return result;
};

/** [주문] 주문 디테일 조회 */
export const getOrderDetail = async (token: string, orderId: string) => {
  const {
    data: { result }
  } = await request(token).get(`/pharms/order/${orderId}`);
  return result;
};

/** [주문] 처방전 읽음 처리 (receivedAt, checkedAt) */
export const setOrderReceive = async (token: string, orderId: string) => {
  const client = request(token);
  setRequestRetry(client, 5);
  await client.put(`/pharms/order/${orderId}/confirm`);
};

/** [주문] 처방전 가격 요청 */
export const setOrderPrice = async (
  token: string,
  params: OrderSetPriceParams
) => {
  const { orderId, useAlternative, price, isFree } = params;
  const { data } = await request(token).put(`/pharms/order/${orderId}`, {
    useAlternative,
    price,
    isFree
  });
  return data;
};

/** [주문] 처방전 거부 */
export const setOrderCancelByPharm = async (
  token: string,
  params: OrderCancelByPharmParams
) => {
  const { orderId, cancelReason } = params;
  await request(token).put(`/pharms/order/${orderId}/cancel`, {
    cancelReason
  });
};

/** [주문] 처방전 주문 취소 by user */
export const setOrderCancelByUser = async (token: string, id: number) => {
  await request(token).put(`/pharms/order/${id}/cancellation`);
};

/** [주문] 약 배차 요청 */
export const setOrderPickupCall = async (
  token: string,
  params: OrderPickupCallParams
) => {
  const { orderId, pickupWishMinutes, alternativeReason } = params;
  await request(token).put(`/pharms/order/${orderId}/call`, {
    deduction: 0,
    pickupWishMinutes,
    alternativeReason
  });
};

/** [주문] 조제 진행 내역 CJ 엑셀 다운로드 */
export const onDownloadCJExcel = async (
  token: string,
  params: SettlementsParams
) => {
  const { from, to } = params;

  const excel = await request(token, 'v2').get(
    '/orders/pickup-check/download',
    {
      responseType: 'blob',
      params: {
        from,
        to
      }
    }
  );

  return excel;
};

export default {
  getRequestedOrders,
  getPreparingOrders,
  getOrderDetail,
  setOrderReceive,
  setOrderPrice,
  setOrderCancelByPharm,
  setOrderCancelByUser,
  setOrderPickupCall,
  onDownloadCJExcel
};
